// extracted by mini-css-extract-plugin
export default {"Room":"Room_Room__-7j36","RoomTabsContainerWrapper":"Room_RoomTabsContainerWrapper__+JPri","PlayerColumn":"Room_PlayerColumn__UtoXs"};